import DOMPurify from "dompurify";

export const formatBodyForCsv = (text: string) => {
  const lines = convertParagraphsToNewlines(text);
  const stripped = stripeHtmlTags(lines);
  return stripped.replace(/&nbsp;|\u00A0/g, " ");
};

export const convertParagraphsToNewlines = (text: string) => {
  return text.replace(/<\/?p>/g, "\n").trim();
};

export const stripeHtmlTags = (text: string) => {
  return DOMPurify.sanitize(text, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
};
